﻿/**
 * Product Card Image Carousel
 * Track is a plain div (no wrapping <a>) so touch events are never blocked.
 * Click-to-navigate is handled via data-href on the carousel div.
 */
(function () {
  'use strict';

  function initCarousel(carousel) {
    if (carousel.dataset.carouselInit) return;
    carousel.dataset.carouselInit = 'true';

    var track = carousel.querySelector('[data-carousel-track]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-dot]'));
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.card__media-carousel-slide')) : [];
    var total = slides.length;
    var productUrl = carousel.getAttribute('data-href');

    if (!track) return;

    var current = 0;
    var didSwipe = false;

    function goTo(index) {
      current = ((index % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    // Click on track area = navigate to product (only if not swiping)
    if (productUrl) {
      carousel.addEventListener('click', function (e) {
        var clickedBtn = e.target.closest('[data-carousel-prev],[data-carousel-next],[data-carousel-dot]');
        if (!clickedBtn && !didSwipe) {
          window.location.href = productUrl;
        }
      });
    }

    // Arrow buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(current - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(current + 1);
      });
    }

    // Dot buttons
    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(parseInt(this.getAttribute('data-carousel-dot'), 10));
      });
    });

    // ── Touch swipe ──────────────────────────────────────────────
    var touchStartX = 0;
    var touchStartY = 0;
    var swipeAxis = null; // 'h' or 'v'

    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      swipeAxis = null;
      didSwipe = false;
    }, { passive: true });

    carousel.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;

      if (!swipeAxis) {
        swipeAxis = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      }

      if (swipeAxis === 'h') {
        e.preventDefault(); // prevent page scroll during horizontal swipe
        didSwipe = true;
      }
    }, { passive: false });

    carousel.addEventListener('touchend', function (e) {
      if (swipeAxis !== 'h') return;
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 30) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    // ── Mouse drag (desktop) ─────────────────────────────────────
    var mouseStartX = 0;
    var mouseMoved = false;

    carousel.addEventListener('mousedown', function (e) {
      mouseStartX = e.clientX;
      mouseMoved = false;
      didSwipe = false;
    });

    carousel.addEventListener('mousemove', function (e) {
      if (e.buttons === 0) return;
      if (Math.abs(e.clientX - mouseStartX) > 5) mouseMoved = true;
    });

    carousel.addEventListener('mouseup', function (e) {
      if (!mouseMoved) return;
      didSwipe = true;
      var diff = mouseStartX - e.clientX;
      if (Math.abs(diff) > 30) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
      // Reset didSwipe after a tick so the click handler sees it
      setTimeout(function () { didSwipe = false; }, 0);
    });
  }

  function initAllCarousels() {
    var carousels = document.querySelectorAll('[data-carousel]:not([data-carousel-init])');
    Array.prototype.forEach.call(carousels, initCarousel);
  }

  // Run on DOM ready
  if (document.readyState !== 'loading') {
    initAllCarousels();
  } else {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  }

  // Debounced observer — catches all async DOM changes (AJAX sections, etc.)
  var timer = null;
  var observer = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(initAllCarousels, 80);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
